import { render, staticRenderFns } from "./DashboardStarter.vue?vue&type=template&id=324de53e&"
import script from "./DashboardStarter.vue?vue&type=script&lang=js&"
export * from "./DashboardStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports